module.exports = __webpack_public_path__ + "img/network-notice-banner.b9f7c795.png";